/*=====================================
    HelpView

    Author: Ac
    CreateTime: 2018 / 09 / 13
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
// import CupoySrefView from 'components/commons/router/CupoySrefView';
import HelpViewSideBar from 'components/help/HelpViewSideBar';
import { Route } from 'react-router-dom';
/*--------------------------
    Styled
--------------------------*/
const SubContainer = GlobalStyle.SubContainer.extend`
    display: flex;
    flex-direction: row;
`;
const MainContent = styled.div`
    flex: 1;
`;
/*--------------------------
    Main Component
--------------------------*/
class HelpView extends Component {

    // static propTypes = {
    // };

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.lazyLoadComponent = this.lazyLoadComponent.bind(this);

        this.state = {
            HelpUpgradeMembershipViewComponent: null,
            // HelpVisitorBookViewComponent: null,
            HelpMemberSuspensionOfPowerViewComponent: null,
            HelpTransactionSecurityViewComponent: null,
            HelpTransactionOrderViewComponent: null,
            HelpBonusBaseIntroViewComponent: null,
            HelpBonusCalcIntroViewComponent: null,
            HelpBonusEligibilityViewComponent: null,
            HelpBonusManualViewComponent: null,
            AboutViewComponent: null,
            DisclaimerViewComponent: null,
            PrivacyPolicyViewComponent: null,
            MemberTermsViewComponent: null,
        };
    }

    componentDidMount(){
        this.lazyLoadComponent();
    }

    lazyLoadComponent(){
        import('components/help/HelpUpgradeMembershipView').then(HelpUpgradeMembershipModule => {
            this.setState({ HelpUpgradeMembershipViewComponent: HelpUpgradeMembershipModule.default })
        });
        // import('components/help/HelpVisitorBookView').then(HelpVisitorBookModule => {
        //     this.setState({ HelpVisitorBookViewComponent: HelpVisitorBookModule.default })
        // });
        import('components/help/HelpMemberSuspensionOfPowerView').then(HelpMemberSuspensionOfPowerModule => {
            this.setState({ HelpMemberSuspensionOfPowerViewComponent: HelpMemberSuspensionOfPowerModule.default })
        });
        import('components/help/HelpTransactionSecurityView').then(HelpTransactionSecurityModule => {
            this.setState({ HelpTransactionSecurityViewComponent: HelpTransactionSecurityModule.default })
        });
        import('components/help/HelpTransactionOrderView').then(HelpTransactionOrderModule => {
            this.setState({ HelpTransactionOrderViewComponent: HelpTransactionOrderModule.default })
        });

        import('components/help/HelpBonusBaseIntroView').then(HelpBonusBaseIntroModule => {
            this.setState({ HelpBonusBaseIntroViewComponent: HelpBonusBaseIntroModule.default })
        });
        import('components/help/HelpBonusCalcIntroView').then(HelpBonusCalcIntroModule => {
            this.setState({ HelpBonusCalcIntroViewComponent: HelpBonusCalcIntroModule.default })
        });
        import('components/help/HelpBonusEligibilityView').then(HelpBonusEligibilityModule => {
            this.setState({ HelpBonusEligibilityViewComponent: HelpBonusEligibilityModule.default })
        });
        import('components/help/HelpBonusManualView').then(HelpBonusManualModule => {
            this.setState({ HelpBonusManualViewComponent: HelpBonusManualModule.default })
        });
        import('components/about/AboutView').then(AboutModule => {
            this.setState({ AboutViewComponent: AboutModule.default })
        });
        import('components/about/DisclaimerView').then(DisclaimerModule => {
            this.setState({ DisclaimerViewComponent: DisclaimerModule.default })
        });
        import('components/about/PrivacyPolicyView').then(PrivacyPolicyModule => {
            this.setState({ PrivacyPolicyViewComponent: PrivacyPolicyModule.default })
        });
        import('components/about/MemberTermsView').then(MemberTermsModule => {
            this.setState({ MemberTermsViewComponent: MemberTermsModule.default })
        });
        
    }

    render() {
        
        return (
            <SubContainer>
                <HelpViewSideBar />
                <MainContent>
                    {this.renderContent()}
                </MainContent>
            </SubContainer>
        );
    }

    renderContent = () => {

        const {
            HelpUpgradeMembershipViewComponent,
            // HelpVisitorBookViewComponent,
            HelpMemberSuspensionOfPowerViewComponent,
            HelpTransactionSecurityViewComponent,
            HelpTransactionOrderViewComponent,
            HelpBonusBaseIntroViewComponent,
            HelpBonusCalcIntroViewComponent,
            HelpBonusEligibilityViewComponent,
            HelpBonusManualViewComponent,
            AboutViewComponent,
            DisclaimerViewComponent,
            PrivacyPolicyViewComponent,
            MemberTermsViewComponent,
        } = this.state;
        
        return (
            <div>
                {HelpUpgradeMembershipViewComponent && <Route path={CupoyRouter.PATHS.HELP_UPGRADE_MEMBERSHIP} component={HelpUpgradeMembershipViewComponent} exact />}
                {/* {HelpVisitorBookViewComponent && <Route path={CupoyRouter.PATHS.HELP_VISITOR_BOOK} component={HelpVisitorBookViewComponent} exact />} */}
                {HelpMemberSuspensionOfPowerViewComponent && <Route path={CupoyRouter.PATHS.HELP_MEMBER_SUSPENSION_OF_POWER} component={HelpMemberSuspensionOfPowerViewComponent} exact />}
                {HelpTransactionSecurityViewComponent && <Route path={CupoyRouter.PATHS.HELP_TRANSACTION_SECURITY} component={HelpTransactionSecurityViewComponent} exact />}
                {HelpTransactionOrderViewComponent && <Route path={CupoyRouter.PATHS.HELP_TRANSACTION_ORDER} component={HelpTransactionOrderViewComponent} exact />}
                {HelpBonusBaseIntroViewComponent && <Route path={CupoyRouter.PATHS.HELP_BONUS_BASE_INTRO} component={HelpBonusBaseIntroViewComponent} exact />}
                {HelpBonusCalcIntroViewComponent && <Route path={CupoyRouter.PATHS.HELP_BONUS_CALC_INTRO} component={HelpBonusCalcIntroViewComponent} exact />}
                {HelpBonusEligibilityViewComponent && <Route path={CupoyRouter.PATHS.HELP_BONUS_ELIGIBILITY} component={HelpBonusEligibilityViewComponent} exact />}
                {HelpBonusManualViewComponent && <Route path={CupoyRouter.PATHS.HELP_BONUS_MANUAL} component={HelpBonusManualViewComponent} exact />}
                {AboutViewComponent && <Route path={CupoyRouter.PATHS.HELP_ABOUT} component={AboutViewComponent} exact />}
                {DisclaimerViewComponent && <Route path={CupoyRouter.PATHS.DISCLAIMER} component={DisclaimerViewComponent} exact />}
                {PrivacyPolicyViewComponent && <Route path={CupoyRouter.PATHS.HELP_PRIVACY_POLICY} component={PrivacyPolicyViewComponent} exact />}
                {MemberTermsViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_TERMS} component={MemberTermsViewComponent} exact />}
            </div>
        );
    }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(HelpView);